'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    width: {
      type: [Number, String],
      default: 750
    },
    height: {
      type: [Number, String],
      default: 600
    },
    startColor: {
      type: String,
      default: '#00A4F2'
    },
    endColor: {
      type: String,
      default: '#F9F9F9'
    }
  },

  data: function data() {
    return {};
  },

  computed: {
    gradientStyle: function gradientStyle() {
      var width = this.width,
          height = this.height,
          startColor = this.startColor,
          endColor = this.endColor;
      //是否为双色渐变，双色渐变处理渐变色透明度为90%

      startColor = '#E6' + startColor.substring(1);
      endColor = '#E6' + endColor.substring(1);
      return {
        width: width + 'px',
        height: height + 'px',
        backgroundImage: 'linear-gradient(to bottom,' + startColor + ', ' + endColor + ')'
      };
    },
    gradientTopStyle: function gradientTopStyle() {
      var width = this.width,
          height = this.height,
          startColor = this.startColor,
          endColor = this.endColor;

      return {
        width: width + 'px',
        height: height + 'px',
        backgroundImage: 'linear-gradient(to bottom, ' + startColor + ', ' + endColor + ')'
      };
    },
    gradientBottomStyle: function gradientBottomStyle() {
      var width = this.width,
          height = this.height,
          startColor = this.startColor,
          endColor = this.endColor;

      return {
        width: width + 'px',
        flex: 1,
        backgroundImage: 'linear-gradient(to bottom, ' + tempColor + ', ' + endColor + ')'
      };
    }
  },
  methods: {}
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-gradient/index.vue
// module id = 331
// module chunks = 0 1